var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCdr = function SvgCdr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#84BD5A",
    d: "M19.6 19.5c0 .413-.337.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.338-.75.75-.75h16.5c.413 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.347 15.895c0-1.157.725-2.152 2.105-2.152.521 0 .935.155 1.373.533.162.15.18.414.017.582a.407.407 0 0 1-.55-.018c-.247-.258-.499-.329-.84-.329-.923 0-1.367.653-1.367 1.385 0 .744.437 1.427 1.367 1.427.341 0 .66-.138.935-.384a.4.4 0 0 1 .551.073c.096.131.144.353-.066.563-.42.39-.923.468-1.42.468-1.451 0-2.105-.99-2.105-2.148M9.243 18c-.198 0-.414-.108-.414-.371v-3.407c0-.215.216-.372.414-.372h1.374c2.74 0 2.68 4.15.054 4.15zm.378-3.418v2.687h.996c1.619 0 1.69-2.687 0-2.687zM14.284 17.61c0 .521-.797.54-.797.012v-3.406c0-.209.162-.366.36-.366h1.594c1.524 0 1.836 2.04.564 2.549l.798.972c.312.462-.312.905-.672.45l-.906-1.296h-.942zm0-1.774h1.157c.78 0 .828-1.26 0-1.26h-1.157z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.413 0 .75-.337.75-.75v-.75c0 .413-.337.75-.75.75"
  })));
};
export default SvgCdr;